import React from 'react';
import styled from '@emotion/styled';
import PropTypes, { InferProps } from 'prop-types';
import Subtitle from './SubTitle';
import colors from '../Theme/colors';

const StyledMenuList = styled(Subtitle)<{ executive?: boolean }>`
  display: block;
  color: ${({ executive }) => (
    executive ? colors.white : colors.black)};
`;

const menuListPropertyTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  executive: PropTypes.bool,
};

type MenuListProperties = InferProps<typeof menuListPropertyTypes>;

const MenuList = ({
  children, className, executive,
}: MenuListProperties) => (
  <StyledMenuList
    className={className}
    executive={executive ?? undefined}
  >
    {children}
  </StyledMenuList>
);

MenuList.propTypes = menuListPropertyTypes;

export default MenuList;
